import { render, staticRenderFns } from "./explore.vue?vue&type=template&id=bf270aa2&scoped=true"
import script from "./explore.vue?vue&type=script&lang=js"
export * from "./explore.vue?vue&type=script&lang=js"
import style0 from "./explore.vue?vue&type=style&index=0&id=bf270aa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf270aa2",
  null
  
)

export default component.exports